import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=b0096596&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=b0096596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0096596",
  null
  
)

export default component.exports